import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api'
import { useWindowSize } from '@vueuse/core'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  emits: ["close"],
  setup(__props) {


const { width } = useWindowSize()
const isMobile = computed(() => width.value < 640)

return { __sfc: true,width, isMobile }
}

})